import { createRoot } from "react-dom/client"

import { patchFetch } from "~/host-app/net/patchFetch"
import { registerApiInterceptors } from "~/host-app/net/registerApiInterceptors"

import HostApp from "../HostApp"
import { devMode } from "~/shared/config"


export function setupHostApp() {

	patchFetch()
	registerApiInterceptors()

	const rootElement = document.getElementById("root")
	if (!rootElement) throw new Error("Корневой элемент не установлен!")

	if (devMode && window.top !== window.self) {

		const ro = new ResizeObserver(() => {
			window.parent.postMessage(
				{ type: "app-frame-resize", height: document.documentElement.scrollHeight },
				"*"
			)
		})

		ro.observe(rootElement)

		const origPushState = history.pushState

		history.pushState = new Proxy(origPushState, {
			apply(target: (data: any, unused: string, url?: (string | URL | null)) => void, thisArg: any, argArray: any[]): any {

				window.parent.postMessage(
					{ type: "app-frame-popstate", pathname: argArray[2] },
					"*"
				)

				return Reflect.apply(target, thisArg, argArray)
			}
		})
	}

	createRoot(rootElement).render(<HostApp />)
}
